module.exports = __webpack_public_path__ + "img/stoofvlees_bread.420d59f5.jpg";